

export default {
    /*
   订单状态
  */
    orderStatusName(status) {
        var map = {
            "in_progress": '充电中',
            "unpaid": '未支付',
            "paid": '已支付',
            "closed": '已关闭',
        };
        return map[status];

    },
    /*
 电桩状态
*/
    chargeStatus(status) {
        var map = {
            "available": "空闲", //空闲
            "offline": "离线", //离线
            "charged": "已充满", //已充满
            "maintaining": "维修中", //维修中
            "ready": "已插枪", //已插槍
            "fault": "异常", //异常
            "charging": "充电中", //充电中
            "null": "未知"
        };
        return map[status];

    },
    /*
提现状态
*/
    withdrawalStatus(status) {
        var map = {
            "pending": "待审核", //空闲
            "rejected": "已拒绝", //离线
            "done": "已提现", //已充满
        };
        return map[status];

    },
    
    /*
    格式化日期为 "MM月DD日" 格式
    */
    formatDate(date) {
        const month = date.getMonth() + 1;
        const day = date.getDate();
        return `${month.toString().padStart(2, '0')}月${day.toString().padStart(2, '0')}日`;
    },
    
    /*
    格式化时间为 "HH:mm" 格式
    */
    formatTime(date) {
        const hours = date.getHours();
        const minutes = date.getMinutes();
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    },
    
    /*
    格式化时长为 "X时X分X秒" 格式
    */
    formatDuration(milliseconds) {
        const totalSeconds = Math.floor(milliseconds / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        
        let result = '';
        if (hours > 0) {
            result += `${hours}时`;
        }
        if (minutes > 0) {
            result += `${minutes}分`;
        }
        if (seconds > 0 || result === '') {
            result += `${seconds}秒`;
        }
        
        return result;
    }
}